import AuthenticationGate from '@/app/authentication-gate/authenticationGate';
import Main from '@/app/layout';
import Devices from '@/pages/devices';
import Inbox from '@/pages/inbox-list';
import InboxDetailsPage from '@/pages/inbox-details';
import Rma from '@/pages/rma-list';
import NewRma from '@/pages/new-rma';
import RmaDetails from '@/pages/rma-details';
import NewStudy from '@/pages/new-study';
import StudiesPage from '@/pages/studies-list';
import StudyManagement from '@/pages/study-management';
import Support from '@/pages/support-list';
import CompleteSupportRequest from '@/pages/complete-support-request';
import NewSupportRequest from '@/pages/new-support-request';
import SupportRequestDetails from '@/pages/support-request-details';
import WebRedirect from '@/pages/web-redirect';
import { SUPPORT_URL_REQUEST_TYPE } from '@/shared/config';
import { Navigate, Route, Routes } from 'react-router-dom';
import CreateReturnShipping from '@/pages/create-return-shipping';
import DiagnosticYield from '@/pages/diagnostic-yield';
import CreateShippingLabel from '@/pages/create-shipping-label';

/**
 * Route table of the portal. Exposes the public complete-support-email, web-redirect and diagnostic-yield routes, then nests the inbox, studies, devices, RMA and support sections, each with their detail and creation children and a catch-all redirect back to its index, inside the authentication gate and the main layout with the inbox as default.
 *
 * @returns The route tree element.
 */
export const AppRoutes = () => (
  <Routes>
    <Route path="/completeSupportEmail/:id" element={<CompleteSupportRequest />} />
    <Route path="/web-redirect" element={<WebRedirect />} />
    <Route path="diagnostic-yield" element={<DiagnosticYield />} />
    <Route
      path="/"
      element={
        <AuthenticationGate>
          <Main />
        </AuthenticationGate>
      }
    >
      <Route path="inbox">
        <Route index element={<Inbox />} />
        <Route path=":reportId" element={<InboxDetailsPage />} />
        <Route path=":reportType/:reportId" element={<InboxDetailsPage />} />
        <Route path="*" element={<Navigate replace to="/inbox" />} />
      </Route>

      <Route path="studies">
        <Route index element={<StudiesPage />} />
        <Route path=":studyId" element={<StudyManagement />} />
        <Route path=":studyId/create-return-shipping" element={<CreateReturnShipping />} />
        <Route path="create/:studyId" element={<NewStudy />} />
        <Route path="create" element={<NewStudy />} />
        <Route path="inbox/:reportId" element={<InboxDetailsPage />} />
        <Route path="*" element={<Navigate replace to="/studies" />} />
      </Route>

      <Route path="devices">
        <Route index element={<Devices />} />
        <Route path="*" element={<Navigate replace to="/devices" />} />
      </Route>

      <Route path="rma">
        <Route index element={<Rma />} />
        <Route path=":id" element={<RmaDetails />} />
        <Route path="new" element={<NewRma />} />
        <Route path="create-shipping-label/:rmaId" element={<CreateShippingLabel />} />
        <Route path="*" element={<Navigate replace to="/rma" />} />
      </Route>

      <Route path="support">
        <Route index element={<Support />} />
        <Route path="new-support-request">
          <Route
            index
            element={<Navigate replace to={SUPPORT_URL_REQUEST_TYPE.changeStudyType} />}
          />
          <Route path=":requestType" element={<NewSupportRequest />} />
        </Route>
        <Route path=":supportId" element={<SupportRequestDetails />} />
        <Route path="*" element={<Navigate replace to="/support" />} />
      </Route>

      <Route index element={<Navigate replace to="/inbox" />} />
      <Route path="*" element={<Navigate replace to="/inbox" />} />
    </Route>
  </Routes>
);
